export default __webpack_public_path__ + "static/media/refresh.866e3b0d.svg";